<script setup lang="ts">
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  forcedToBeOpen: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  topPlush: {
    default: null,
  },
});

const emit = defineEmits(['close']);

const close = () => {
  if (props.forcedToBeOpen) {
    return;
  }

  emit('close');
};
</script>

<template>
  <transition name="fade">
    <div v-if="isOpen || forcedToBeOpen" class="modal-overlay" @click.self="close">
      <div class="modal-container">
        <div class="modal-content-wrapper">
          <img v-if="topPlush !== null"
            :src="topPlush"
            alt=""
            class="modal-top-image"
          />
          <div class="modal-content">
            <button class="modal-close" v-if="!forcedToBeOpen" @click="close">
              &times;
            </button>
            <h3 v-if="title" class="modal-title">{{ title }}</h3>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-container {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.modal-content-wrapper {
  position: relative;
}

.modal-top-image {
  position: absolute;
  top: 0;
  left: 50px;
  transform: translateY(-100%);
  width: 150px;
  height: auto;
  z-index: 10;
  pointer-events: none;
  user-select: none;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: modal-appear 0.3s ease-out;
  z-index: 5;
  margin: 10px auto;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  line-height: 1;
}

.modal-close:hover {
  color: #333;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
  color: #333;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .modal-content {
    width: 95%;
    padding: 20px 15px;
  }

  .modal-top-image {
    width: 120px;
    left: 20px;
  }
}
</style>
